function loremblocksum(length) {
  length = parseInt(length, 10);
  const sentenceArray = [];

  while (sentenceArray.join(' ').length < length) {
    const wordLength = Math.round(Math.random() * 7) + 1;
    let word = '█';

    while (word.length < wordLength) {
      word += '█';
    }

    sentenceArray.push(word);
  }

  return sentenceArray.join(' ');
}

module.exports = loremblocksum;



// WEBPACK FOOTER //
// ./src/libs/twig/loremblocksum/index.js